import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from "src/modules/auth/store";

class CompaniesAdminStore {
  @observable
  public all_companies: any[];

  @observable
  public loaded: boolean = false;

  @observable
  public currentCompany: any;

  @observable
  public current_company_roles: any[];

  @observable
  public all_sites: any[];

  //D-011
  @observable
  public all_distributor: any[];


  constructor() {
    // this.retrieveCompanies();
    this.getSitesList();
    this.getDistributorList(); //D-011
  }

  @action
  public retrieveCompanies = async () => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/companies/all",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authStore.currentUser.SessionKey || "",
          // Authorization: "" || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.all_companies = responseJson.body;
    this.loaded = true;
  };

  @action
  public setBlankCompany = () => {
    this.currentCompany = {
      company_id: 0,
      CompanyName: '',
      CompanyDescription: '',
      CompanyAddress: '',
      CompanyCity: '',
      CompanyState: '',
      CompanyZip: '',
      CompanyPhone: '',
      CompanyEmail: '',
      CompanyWebAddress: '',
      CompanyBillingContactName: '',
      CompanyBillingContactPhone: '',
      CompanyBillingContactEmail: '',
      CompanyBusinessType: '', //D-011
      CompanyApprovalOrderEmail: '', //D-023
      allowUsersForEsign: 0, // C-108
      CompanyMinTransactionFee:'', // E-105
      claimApprovalDetermination :'grossProfit', // E-105 new
      isTransactionFeeUpdated : 0, // E-105 new
      CompanySiteList: []
    }
  }
//get All sites
  @action
  public getSitesList = async () => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/companies/sites/list",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.all_sites = responseJson.body;
  }

  /**
 * D-011 getDistributorList
 */
  @action
  public getDistributorList = async () => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/companies/distributor/list",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.all_distributor = responseJson.body;
  }

  @action
  public getCompanyByID = async (company_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/companies/get/" + company_id,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.currentCompany = responseJson.body;
    this.loaded = true;
  };

  @action
  public retrieveRolesByCompany = async (company_id: number) => {
    const response: Response = await fetch(
      config.BASE_URL + '/api/companies/' + company_id + '/roles',
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authStore.currentUser.SessionKey || "",
        },
        method: "GET",
      }
    );
    const responseJson = await response.json();
    this.current_company_roles = responseJson.body;
  }

  @action
  public saveCompany = async (company: any) => {
    const response: Response = await fetch(
      config.BASE_URL + "/api/companies/save",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          company
        }),
      }
    );
    const result = await response.json();
    // this.saveUser(await result.body);
    await this.retrieveCompanies();
  }

    @action
    public disableCompany = async (company_id: number) => {
      const response: Response = await fetch(
        config.BASE_URL + "/api/companies/disableComp/" + company_id,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: authStore.currentUser.SessionKey || "",
          },
          method: "POST",
          body: JSON.stringify({
          company_id,
          }),
        }
      );
      const responseJson = await response.json();
  
      await this.retrieveCompanies();
    };
  
    @action
    public enableCompany = async (company_id: number) => {
      const response: Response = await fetch(
        config.BASE_URL + "/api/companies/enableCompany/" + company_id,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            company_id,
          }),
        }
      );
      const responseJson = await response.json();
  
      await this.retrieveCompanies();
    };
    
}

export default new CompaniesAdminStore();



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/companies_admin.store.ts